module.exports = __webpack_public_path__ + "static/media/logo_white.fcd0c252.svg";